import React, { FC, useEffect } from "react";
import { Form, DatePicker, Radio, Select, Row, Col } from "antd";
import dayjs from "dayjs";

type AdmissionDataNewProps = {
  form: any;
  isDisabled?: boolean;
  doa?: string;
};

const admissionTypeOptions = [
  { label: "Planned", value: "planned" },
  { label: "Emergency", value: "emergency" },
];

const AdmissionDataNew: FC<AdmissionDataNewProps> = ({
  form,
  isDisabled,
  doa,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  useEffect(() => {
    if (!form.getFieldValue("medicoLegalCase")) {
      form.setFieldValue("medicoLegalCase", false);
    }
  }, [form]);

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
        }}
      >
        Admission Data
      </div>

      <Form
        form={form}
        layout="vertical"
        labelAlign="left"
        labelWrap
        style={{ width: "100%", padding: "8px" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Admission Date"
              name="admissionDate"
              rules={[
                { required: true, message: "Please select Admission Date" },
              ]}
            >
              <DatePicker
                showTime
                format={dateFormat}
                // disabledDate={(current) => {
                //   return (
                //     current.isBefore(
                //       dayjs(doa, dateFormat).subtract(1, "day"),
                //       "day"
                //     ) ||
                //     current.isAfter(dayjs(doa, dateFormat).add(1, "day"), "day")
                //   );
                // }}
                style={{ width: "100%" }}
                placeholder="Select Admission Date"
                disabled={isDisabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Surgery Treatment Start Date"
              name="surgeryTreatmentStartDate"
              rules={[
                {
                  required: true,
                  message: "Please select Surgery Treatment Start Date",
                },
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                placeholder="Select Surgery Start Date"
                disabled={isDisabled}
                disabledDate={(current) => {
                  const admission = form.getFieldValue("admissionDate");
                  if (!admission) return false;
                  return current && current.isBefore(dayjs(admission), "day");
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Medico Legal Case"
              name="medicoLegalCase"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Radio.Group
                options={[
                  { label: "yes", value: true },
                  { label: "no", value: false },
                ]}
                disabled={isDisabled}
              ></Radio.Group>
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Admission Type"
              name="admissionType"
              rules={[
                { required: true, message: "Please select Admission Type" },
              ]}
            >
              <Select
                placeholder="Select"
                options={admissionTypeOptions}
                allowClear
                disabled={isDisabled}
              />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </>
  );
};

export default AdmissionDataNew;
